import Vue from 'vue'
import errorHandlerPlugin from './plugins/errorHandler';
import ElementUI from 'element-ui';
import scroll from 'vue-seamless-scroll'
import * as echarts from 'echarts'
import $ from 'jquery'
// import './util/rem'
import 'element-ui/lib/theme-chalk/index.css';
// import './config/rem'
import './config/amfe-flexible'
import { createApp } from 'vue'
import axiosInstance from './api/axios';
import errorHandler from './util/errorHandler';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import totalFun from './util/nowTime'
import BaiduMap from 'vue-baidu-map'
import App from './App.vue';
import store from './store';
import router from './router'

import './main.less';

Vue.prototype.$video = videojs;
Vue.use(BaiduMap, {
  ak: 'gsYXN4Pd6p2GXCPupGZkz6wNDINs7eon'  //这个地方是官方提供的ak密钥
})
Vue.use(ElementUI);
Vue.use(scroll)
Vue.prototype.$echarts = echarts
Vue.prototype.$ = $
// 将 axios 实例注入到 Vue 的原型中
Vue.prototype.$axios = axiosInstance;
Vue.prototype.totalFun = totalFun;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  renderError(h, err) {
    return h("pre", { style: { color: "red" } }, err.stack);
}
}).$mount('#app')
